import React from "react";

import { parse, parseNumbers } from "../Helpers/parse";
import ProgressBar from "./Helpers/Progress";
import copy from "copy-to-clipboard";
import axios from "axios";
import { Helmet } from "react-helmet-async";

import { getQueryVariable } from "Helpers/QueryString";

import Video from "./NewFuncComponents/Video";
import { GlobalContext } from "../Context/GlobalContext";

const VIEWS_URL = "https://m513nl9tlc.execute-api.us-west-2.amazonaws.com/";

const EMBED_STYLE = `
  body {
    background-color: rgb(0,0,0);
  }
  div#root, div.app-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`

class Embed extends React.Component {
  static contextType = GlobalContext;

  constructor() {
    super();
    this.state = {
      file: { metadata: {}, likes: [], dislikes: [], comments: [], views: [] },
      checkout: false,
      liveURL: "https://ak0i1ibny3.execute-api.us-west-2.amazonaws.com/default",
      playNext: false,
      shouldUpdate: false,
      scrubTo: 0,
      currentTime: 0,
      watchToken: null,
      schedule: [],
      schedule_info: {},
      schedule_metadata: {},
      lastViewUpdate: 0,
      liveViewCount: 0,
      itemBeingBought: "",
    };
    this.mounted = false;
    this.updateLiveViewsTimeout = null;
  }

  componentDidMount() {
    this.mounted = true;
    window.scrollTo(0, 0);

    const validChars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+{}:";
    let array = new Uint8Array(256);
    window.crypto.getRandomValues(array);
    array = array.map((x) => validChars.charCodeAt(x % validChars.length));
    const randomState = String.fromCharCode.apply(null, array);

    // window.addEventListener("beforeunload", this.setViews);
    this.setState({ id: this.props.video, watchToken: randomState });
    if (getQueryVariable("type") === "live") {
      this.startLive();
      this.updateLiveViews();
      //   let watchToken = crypto.lib.WordArray.random(256).words.join("");
      axios
        .get(
          `https://9efovgrib0.execute-api.us-west-2.amazonaws.com/${this.props.video}?type=live`
        )
        .then((res) => {
          if (this.mounted && res.data) {
            this.startLive();
            this.updateLiveViews();
            this.setState({
              file: res.data,
              // liked:
              //   this.props.pub_user &&
              //   res.data.likes.includes(this.props.pub_user._id),
              // disliked:
              //   this.props.pub_user &&
              //   res.data.dislikes.includes(this.props.pub_user._id),
              shared: false,
            });
          }
        });
      /*
      axios
        .post(this.props.url + "/upload/infoLive", {
          live: this.props.video,
        })
        .then((res) => {
          //   this.startLive();
          if(this.mounted) {
            this.updateLiveViews();
            this.setState({
              file: res.data.response.payload.live,
              liked: res.data.response.payload.live.likes.includes(
                this.props.pub_user._id
              ),
              disliked: res.data.response.payload.live.dislikes.includes(
                this.props.pub_user._id
              ),
              shared: false,
            });
          }
        });*/
    } else {
      axios
        .post(this.props.url + "/upload/info", {
          file: this.props.video,
        })
        .then((res) => {
          if (this.mounted) {
            this.setState({
              file: res.data.response.payload.file,
              liked: res.data.response.payload.file.likes.includes(
                this.props.pub_user._id
              ),
              disliked: res.data.response.payload.file.dislikes.includes(
                this.props.pub_user._id
              ),
              shared: false,
            });
          }
        });
    }
  }
  componentDidUpdate() {
    if (this.props.pub_user && this.state._id !== this.props.pub_user._id) {
      let file = this.state.file;
      if (
        file.downloadBuys &&
        file.downloadBuys.includes(this.props.pub_user._id)
      ) {
        file.downloadPrice = 0;
        this.setState({ file });
      }
      this.setState({ _id: this.props.pub_user._id });
    }
    if (this.state.id !== this.props.video) {
      this.setState({ id: this.props.video });
      axios
        .post(this.props.url + "/upload/info", {
          file: this.props.video,
        })
        .then((res) => {
          if (this.mounted) {
            this.setState({
              file: res.data.response.payload.file,
              // liked: res.data.response.payload.file.likes.includes(
              //   this.props.pub_user._id
              // ),
              // disliked: res.data.response.payload.file.dislikes.includes(
              //   this.props.pub_user._id
              // ),
              shared: false,
            });
          }
        });
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  startLive = () => {
    if (this.mounted) {
      try {
        axios
          .post(this.props.url + "/upload/infoLive", {
            live: this.props.video,
          })
          .then(
            (res) => {
              if (this.mounted) {
                this.setState({
                  id: res.data.response.payload.live._id,
                  file: res.data.response.payload.live,
                  // liked:
                  //   this.props.pub_user &&
                  //   res.data.response.payload.live.likes.includes(
                  //     this.props.pub_user._id
                  //   ),
                  // disliked:
                  //   this.props.pub_user &&
                  //   res.data.response.payload.live.dislikes.includes(
                  //     this.props.pub_user._id
                  //   ),
                  shared: false,
                });
              }
            },
            () => {
              console.error("There was an error getting live info.");
              this.startLive();
            }
          );
      } catch (e) {}
    }
  };
  updateLiveViews = async () => {
    try {
      let { id } = this.state;
      let res = await axios.get(VIEWS_URL + "live/recent/" + id);
      if (this.mounted) {
        this.setState({
          liveViewCount: parseInt(res.data, 10),
        });
      }
    } catch (err) {
      console.error("Error getting live views:");
      console.error(err);
    }
    if (this.mounted) {
      // Don't start polling twice
      if (this.updateLiveViewsTimeout) {
        clearTimeout(this.updateLiveViewsTimeout);
      }
      this.updateLiveViewsTimeout = setTimeout(this.updateLiveViews, 10000);
    }
  };
  parseLive = () => {
    let views = 0;
    if (this.state.liveViewCount) {
      views = this.state.liveViewCount;
      // Fallback for old behavior
    } else if (this.state.file && this.state.file.views) {
      views = this.state.file.views.filter((item) => {
        if (
          item.end &&
          new Date().getTime() - new Date(item.end).getTime() > 60000
        ) {
          return false;
        } else {
          return true;
        }
      }).length;
    }
    return `${views} watching now`;
  };
  setViews = (force = false, viewData = {}, type) => {
    if (!type) {
      type = getQueryVariable("type");
    }
    let now = Date.now();
    if (
      this.state.watchToken &&
      (now - this.state.lastViewUpdate > 30000 || force)
    ) {
      if (type === "live") {
        axios.post(VIEWS_URL + "live/view", {
          file: this.props.video,
          view: {
            user: this.state.watchToken,
            ...viewData,
          },
        });
      } else if (
        this.state.file &&
        this.state.file._id &&
        this.state.watchTime > 0
      ) {
        axios.post(VIEWS_URL + "video/view", {
          file: {
            _id: this.state.file._id,
          },
          view: {
            watchTime: this.state.watchTime,
            user:
              this.props.pub_user && this.props.pub_user._id
                ? this.props.pub_user._id
                : this.state.watchToken,
            ...viewData,
          },
        });
      } else {
        // Do not set last view update if we did not actually update the view
        return;
      }
      // This needs to be in this block, otherwise views won't update correctly
      if (this.mounted) {
        this.setState((state) => ({ ...state, lastViewUpdate: now }));
      }
    }
  };

  render() {
    const { config } = this.context;
    return (
      <>
        <Helmet>
          <style>
            {EMBED_STYLE}
          </style>
        </Helmet>
        {/* <Helmet>
          <meta
            name="description"
            content={this.state.file.metadata.description}
          />
          <meta name="title" content={this.state.file.metadata.filename} />
          <meta
            name="og:description"
            content={this.state.file.metadata.description}
          />
          <meta name="og:title" content={this.state.file.metadata.filename} />
          <meta
            name="og:image"
            content={`https://dlttx48mxf9m3.cloudfront.net/outputs/${
              this.props.video
            }/Default/Thumbnails/out_003.png?refresh=${Math.random()}`}
          />
          <meta
            name="twitter:description"
            content={this.state.file.metadata.description}
          />
          <meta
            name="twitter:title"
            content={this.state.file.metadata.filename}
          />
          <meta
            name="twitter:image"
            content={`https://dlttx48mxf9m3.cloudfront.net/outputs/${
              this.props.video
            }/Default/Thumbnails/out_003.png?refresh=${Math.random()}`}
          />
        </Helmet> */}
        <Video
          video={this.props.video}
          embed={true}
          color={this.props.color}
          file={this.state.file}
          url={this.props.url}
          user={this.props.user}
          pub_user={this.props.pub_user}
          setItemBeingBought={() => {}}
          register={() => {}}
          setViews={this.setViews}
          videoProps={{
            onTimeUpdate: () => this.setViews(),
            onPause: () => this.setViews(true),
            onPlay: () => this.setViews(true),
          }}
          update={(time) => {
            if (this.state.currentTime !== time) {
              this.setState({ currentTime: time });
              // console.log(
              //   Math.abs(time - this.state.file.metadata.duration)
              // );
              if (Math.abs(time - this.state.file.metadata.duration) < 1.5) {
                this.setState({ watchTime: time });
                setTimeout(() => {
                  this.setState({ playNext: true });
                }, 5000);
              } else {
                this.setState({ watchTime: time, playNext: true });
              }
            }
          }}
          type={getQueryVariable("type") ? getQueryVariable("type") : "video"}
        />
        {this.props.showDetails ? (
          <div
            className="flex-row"
            style={{ justifyContent: "space-between", padding: ".5rem" }}
          >
            <div className="mb-3 flex-1">
              <h1 className="display-4 sm">
                {this.state.file.metadata
                  ? this.state.file.metadata.filename
                  : this.state.file.name}
              </h1>
              <h1 className="dt">
                {!config.hideViews && getQueryVariable("type") === "live"
                  ? this.parseLive()
                  : this.state.file.views.length === 1
                  ? `${parseNumbers(this.state.file.views.length)} view`
                  : `${parseNumbers(this.state.file.views.length)} views`}
                {getQueryVariable("type") !== "live" ? "· " : " "}
                {getQueryVariable("type") !== "live"
                  ? parse(new Date(this.state.file.date))
                  : ""}
              </h1>
              <h1 className="dt" style={{ whiteSpace: "pre-wrap" }}>
                {"\n"}
                {this.state.file.metadata
                  ? this.state.file.metadata.description
                  : ""}
              </h1>
            </div>
            <div
              className="mb-3 social flex-row flex-half"
              style={{
                justifyContent: "space-evenly",
                alignItems: "flex-end",
              }}
            >
              <div
                className={
                  "social-item " + (this.state.liked ? "" : "text-secondary")
                }
                style={{
                  color: this.state.liked ? this.props.color : "",
                }}
              >
                <i
                  className={
                    "fas fa-thumbs-up " +
                    (this.state.liked ? "" : "text-secondary")
                  }
                  style={{
                    color: this.state.liked ? this.props.color : "",
                  }}
                  onClick={() => {
                    if (this.props.pub_user._id !== "") {
                      if (this.state.liked) {
                        axios
                          .post(
                            this.props.url +
                              "/upload/like" +
                              (getQueryVariable("type")
                                ? getQueryVariable("type") === "live"
                                  ? "Live"
                                  : ""
                                : ""),
                            {
                              file: this.state.file,
                              user: this.props.pub_user,
                              action: "pull",
                            }
                          )
                      } else {
                        axios
                          .post(
                            this.props.url +
                              "/upload/like" +
                              (getQueryVariable("type")
                                ? getQueryVariable("type") === "live"
                                  ? "Live"
                                  : ""
                                : ""),
                            {
                              file: this.state.file,
                              user: this.props.pub_user,
                              action: "push",
                            }
                          )
                          .then((res) => {
                            console.log(res.data);
                          });
                      }
                      if (this.state.disliked) {
                        axios
                          .post(
                            this.props.url +
                              "/upload/dislike" +
                              (getQueryVariable("type")
                                ? getQueryVariable("type") === "live"
                                  ? "Live"
                                  : ""
                                : ""),
                            {
                              file: this.state.file,
                              user: this.props.pub_user,
                              action: "pull",
                            }
                          )
                          .then((res) => {
                            console.log(res.data);
                          });
                      }
                      this.setState({
                        liked: !this.state.liked,
                        disliked:
                          this.state.disliked && !this.state.liked
                            ? false
                            : this.state.disliked,
                      });
                    }
                  }}
                ></i>
                {parseNumbers(
                  this.state.file.likes.length + (this.state.liked | 0)
                )}
              </div>

              <div
                className={
                  "social-item " + (this.state.disliked ? "" : "text-secondary")
                }
                style={{
                  color: this.state.disliked ? this.props.color : "",
                }}
              >
                <i
                  className={
                    "fas fa-thumbs-up rotate " +
                    (this.state.disliked ? "" : "text-secondary")
                  }
                  style={{
                    color: this.state.liked ? this.props.color : "",
                  }}
                  onClick={() => {
                    if (this.props.pub_user._id !== "") {
                      if (this.state.disliked) {
                        axios
                          .post(
                            this.props.url +
                              "/upload/dislike" +
                              (getQueryVariable("type")
                                ? getQueryVariable("type") === "live"
                                  ? "Live"
                                  : ""
                                : ""),
                            {
                              file: this.state.file,
                              user: this.props.pub_user,
                              action: "pull",
                            }
                          )
                          .then((res) => {
                            console.log(res.data);
                          });
                      } else {
                        axios
                          .post(
                            this.props.url +
                              "/upload/dislike" +
                              (getQueryVariable("type")
                                ? getQueryVariable("type") === "live"
                                  ? "Live"
                                  : ""
                                : ""),
                            {
                              file: this.state.file,
                              user: this.props.pub_user,
                              action: "push",
                            }
                          )
                          .then((res) => {
                            console.log(res.data);
                          });
                      }
                      if (this.state.liked) {
                        axios
                          .post(
                            this.props.url +
                              "/upload/like" +
                              (getQueryVariable("type")
                                ? getQueryVariable("type") === "live"
                                  ? "Live"
                                  : ""
                                : ""),
                            {
                              file: this.state.file,
                              user: this.props.pub_user,
                              action: "pull",
                            }
                          )
                          .then((res) => {
                            console.log(res.data);
                          });
                      }
                      this.setState({
                        disliked: !this.state.disliked,
                        liked:
                          this.state.liked && !this.state.disliked
                            ? false
                            : this.state.liked,
                      });
                    }
                  }}
                ></i>
                {parseNumbers(
                  this.state.file.dislikes.length + (this.state.disliked | 0)
                )}
              </div>
              <div className={"social-item text-secondary"}>
                <i
                  className={"fas fa-share text-secondary"}
                  onClick={() => {
                    this.setState({ shared: true });
                  }}
                  style={{ cursor: "pointer" }}
                ></i>
                SHARE
                <div
                  className={
                    "share-options " +
                    (this.state.shared ? "share-animate" : "")
                  }
                  style={{
                    backgroundColor: this.props.color,
                    display: this.state.shared ? "flex" : "none",
                  }}
                >
                  <div
                    className="share-item"
                    onClick={() => {
                      copy(window.location.href);
                      this.setState({ copied: true });
                    }}
                  >
                    <i
                      className={
                        "fas text-white " +
                        (this.state.copied ? "fa-check" : "fa-link")
                      }
                    ></i>
                  </div>
                  <div
                    className={
                      "share-item " +
                      (this.state.downloadPercentage > 0 &&
                      this.state.downloadPercentage !== 100
                        ? ""
                        : "d-none")
                    }
                  >
                    <ProgressBar
                      strokeWidth="4"
                      sqSize="20"
                      percentage={this.state.downloadPercentage}
                      visible={
                        this.state.downloadPercentage > 0 &&
                        this.state.downloadPercentage !== 100
                      }
                    />
                  </div>
                  <div
                    className={
                      "share-item " +
                      ((this.state.downloadPercentage > 0 &&
                        this.state.downloadPercentage !== 100) ||
                      (this.state.file.switches &&
                        this.state.file.switches.downloadeble.selected ===
                          "disabled")
                        ? "d-none"
                        : "")
                    }
                    onClick={() => {
                      axios
                        .post(this.props.url + "/upload/get", {
                          file: this.props.video,
                        })
                        .then((res) => {
                          if (res.data.response.success) {
                            axios({
                              url: res.data.response.payload.data, //your url
                              method: "GET",
                              responseType: "blob", // important
                              onDownloadProgress: (progressEvent) => {
                                const totalLength =
                                  progressEvent.lengthComputable
                                    ? progressEvent.total
                                    : progressEvent.target.getResponseHeader(
                                        "content-length"
                                      ) ||
                                      progressEvent.target.getResponseHeader(
                                        "x-decompressed-content-length"
                                      );
                                console.log(
                                  (progressEvent.loaded * 100) / totalLength
                                );
                                if (totalLength !== null) {
                                  this.setState({
                                    downloadPercentage:
                                      (progressEvent.loaded * 100) /
                                      totalLength,
                                  });
                                }
                              },
                            }).then((response) => {
                              const url = window.URL.createObjectURL(
                                new Blob([response.data])
                              );
                              const link = document.createElement("a");
                              link.href = url;
                              link.setAttribute(
                                "download",
                                `${this.state.file.metadata.filename}.mp4`
                              ); //or any other extension
                              document.body.appendChild(link);
                              link.click();
                            });
                          } else {
                          }
                        });
                    }}
                  >
                    <i
                      className={
                        "fas text-white " +
                        (this.state.downloadPercentage === 100
                          ? "fa-check"
                          : "fa-download")
                      }
                    ></i>
                  </div>
                  <div
                    className="share-item"
                    onClick={() => {
                      let embed = `
                        <iframe
                            src="${
                              window.location.href
                                .replace("/video/", "/embed/")
                                .split("embedID=")[0]
                            }embedID=${this.props.video}"
                            allowtransparency="true"
                            frameborder="0"
                            width="560"
                            sandbox="allow-same-origin allow-forms allow-scripts"
                            scrolling="auto"
                            allowfullscreen
                            style="border:none;border-radius:4px;"
                            id="${this.props.video}"
                            onload="AdjustIframeHeightOnLoad('${
                              this.props.video
                            }')"
                        ></iframe>
                        `;
                      copy(embed);
                      this.setState({ embedCopy: true });
                    }}
                  >
                    <i
                      className={
                        "fas text-white " +
                        (this.state.embedCopy ? "fa-check" : "fa-code")
                      }
                    ></i>
                  </div>
                  <div
                    className="share-item"
                    onClick={() => {
                      this.setState({
                        shared: false,
                        embedCopy: false,
                        copied: false,
                        downloadPercentage: 0,
                      });
                    }}
                  >
                    <i className="fas fa-times text-white"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
}
export default Embed;
